import { logo1, bg1, logo2, song, bg2, success } from "../assets";
import { InputCustom } from "../components/Input";
import { ButtonRegiter } from "../components/Button";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import useDevice, { options, url } from "../util";
import * as yup from "yup";

const Banner = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [ok, setOk] = useState(false);
  const device = useDevice();
  const formik = useFormik({
    validationSchema: yup.object().shape({
      fullname: yup.string().required(),
      email: yup.string().required(),
      phoneNumber: yup.string().required(),
      age: yup.string().required(),
      income: yup.string().required(),
    }),
    validateOnChange: false,
    validateOnBlur: false,
    initialValues: {
      fullname: "",
      email: "",
      phoneNumber: "",
      age: "",
      income: "",
      typeRegis: "1",
    },
    onSubmit: (values) => {
      fetch(url, options(values))
        .then((response) => {
          if (!response.ok) {
            throw new Error(
              "Network response was not ok " + response.statusText
            );
          }
          return response.json();
        })
        .then((data) => {
          setOk(true);
          setTimeout(() => {
            setOk(false);
          }, 4000);
        })
        .catch((error) => {
          console.error("error", error);
        });
    },
  });

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIsLoaded((prev) => !prev);
    }, 6000);

    return () => clearInterval(intervalId);
  }, []);
  return (
    <div className="w-screen h-[350px] sm:h-[700px] lg:h-[857px] relative">
      <img
        className={`fade-in-image ${
          isLoaded ? "visible" : ""
        } bg-img absolute z-[-1] min-w-[738px] h-[329px] right-[-50px] sm:right-[-62px] sm:min-w-[1313px] sm:h-[586px] lg:right-0 lg:min-w-[1920px] lg:h-[857px]`}
        src={bg1}
        alt=""
      />
      <img
        className={`fade-in-image ${
          isLoaded ? "" : "visible"
        } bg-img absolute z-[-1] min-w-[738px] h-[329px] right-[-50px] sm:right-[-62px] sm:min-w-[1313px] sm:h-[586px] lg:right-0 lg:min-w-[1920px] lg:h-[857px]`}
        src={bg2}
        alt=""
      />
      <img
        className=" absolute right-0 z-[-1] w-[100%] h-[108px] bottom-0 sm:h-[205px] lg:h-[465px] lg:bottom-[-257px]"
        src={song}
        alt=""
      />
      <div className="flex justify-between pt-[12px] max-w-[1156px] mx-auto px-[20px] items-center">
        <img
          className="h-[30px] sm:h-[73px] lg:h-[97px] cursor-pointer"
          onClick={() =>
            (window.location.href = "https://www.baovietnhantho.com.vn/#gref")
          }
          src={logo1}
          alt=""
        />
        <div className="text-[#ffffff] text-[16px] font-[500] sm:text-[20px] lg:text-[24px]">
          1900 558899
        </div>
      </div>
      <div className=" max-w-[346px] sm:max-w-[786px] lg:max-w-[1116px] mt-[238px] sm:mt-[400px] lg:mt-[45px] mx-auto">
        <div className=" w-100% lg:w-[331px] p-[15px] sm:p-[25px] rounded-[20px] bg-[#ffffff] flex flex-col items-center relative">
          <div className="flex mb-[15px] items-center lg:flex-col lg:mb-[10px]">
            <div className="text-[#005dd7] text-[23px] font-[400] mr-[10px] sm:text-[32px] lg:text-[28px] lg:font-[600] lg:mb-[20px] lg:mr-0">
              {device === "desktop" ? "THAM GIA CÙNG" : "THAM GIA CÙNG -"}
            </div>
            <img
              className="w-[103px] sm:w-[123px] lg:w-[243px] lg:mb-[20px]"
              src={logo2}
              alt=""
              height={"52px"}
            />
          </div>
          <div className="w-[100%] flex flex-col sm:flex-row lg:flex-col gap-[20px] mb-[20px]">
            <InputCustom
              className="sm:w-[370px] lg:w-[100%]"
              placeholder={"Họ và tên"}
              onChange={(e) => {
                formik.setFieldValue("fullname", e.target.value);
              }}
              value={formik.values.fullname}
              error={formik.errors.fullname && formik.touched.fullname}
            />
            <div className="w-full flex justify-between sm:w-[370px] lg:w-[100%]">
              <InputCustom
                width={"70%"}
                placeholder={"Số điện thoại"}
                onChange={(e) => {
                  formik.setFieldValue("phoneNumber", e.target.value);
                }}
                value={formik.values.phoneNumber}
                error={formik.errors.phoneNumber && formik.touched.phoneNumber}
              />
              <InputCustom
                width={"25%"}
                placeholder={"Tuổi"}
                onChange={(e) => {
                  formik.setFieldValue("age", e.target.value);
                }}
                value={formik.values.age}
                error={formik.errors.age && formik.touched.age}
              />
            </div>
          </div>
          <div
            className={`w-[100%] flex lg:flex-col gap-[20px] ${
              formik.isValid ? "mb-[26px]" : "mb-[2px]"
            }`}
          >
            <InputCustom
              width={"100%"}
              placeholder={"Email"}
              onChange={(e) => {
                formik.setFieldValue("email", e.target.value);
              }}
              value={formik.values.email}
              error={formik.errors.email && formik.touched.email}
            />
            <InputCustom
              width={"100%"}
              placeholder={"Thu nhập mong muốn"}
              onChange={(e) => {
                formik.setFieldValue("income", e.target.value);
              }}
              value={formik.values.income}
              error={formik.errors.income && formik.touched.income}
            />
          </div>
          {!formik.isValid && (
            <div className="text-[#ff0000bf] text-[16px]">
              Vui lòng điền đầy đủ thông tin
            </div>
          )}
          <ButtonRegiter
            onClick={() => formik.handleSubmit()}
            className="button"
            width={"100%"}
          />
          {ok && (
            <div className="absolute bg-white h-[100%] w-[100%] rounded-[20px] flex justify-center items-center top-0 left-0">
              <img src={success} alt="" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Banner;
